import axios, { AxiosRequestConfig } from 'axios';
import get from 'lodash/get';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useAppConfig = <T extends unknown>(
  name: string | string[],
  axiosCfg: ExtendedAxiosRequestConfig = {},
  queryOptions: UseQueryOptions<T, Error> = {}
): UseAppConfigResult<T> => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<T, Error>({
    queryKey: ['/app/config/search', name, ...queryKey].filter(Boolean) as string[],

    queryFn: async (): Promise<T> => {
      const fields = Array.isArray(name) ? name : [name];
      const body = { intent: '', fields, criterion: [], sort: [], page: 0, pageSize: 0 };

      const axiosRes = await axios.request<UseGetResponse>({ url: `/app/config/search`, method: 'POST', data: body, ...axiosCfg });

      if (Array.isArray(name)) return axiosRes.data.Data as T;
      return get(axiosRes.data.Data, name, null) as T;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

type UseGetResponse = {
  Data: Record<string, unknown>;
};

type UseAppConfigResult<T> = UseQueryResult<T, Error>;

type ExtendedAxiosRequestConfig = AxiosRequestConfig;
